<template>
    <ConfirmDialog />
    <Toast />
	<div class="grid nested-grid">
		<div class="col-12">
			<div class="card fluid cardheader">
				<div class="col-12">
					<h5 class="stationsHeader">{{ translated('paymenttypestitle') }}</h5>
				</div>												
			</div>
            <DataTable :value="paymenttypes" class="p-datatable-sm" removableSort showGridlines dataKey="id" 
            v-model:filters="filters1" :loading="loading1" responsiveLayout="scroll" :rowHover="true"
            :globalFilterFields="['Name','Description','MeanOfPayment']"
            >

            <!-- :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,30,50]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" -->

                    <template #header>
                        <div class="flex justify-content-between">
                            <Button :label="translated('addnewpaymenttype')" :disabled="isReadOnly" icon="pi pi-plus" class="p-button" @click="openModalAddPaymentType()"  />	
                            <span class="p-input-icon-right">
                                <i class="pi pi-search" />
                                <InputText v-model="filters1['global'].value" :placeholder="translated('keywordsearch')" />
                            </span>
                        </div>
                    </template>        
                    <template #empty>
                        No customers found.
                    </template>
                    <template #loading>
                        Loading customers data. Please wait.
                    </template>    
                    
                <Column :header="translated('companyname')" field="Name" :sortable="true"></Column>
                <Column :header="translated('paymentmeantable')" field="MeanOfPayment" :sortable="true"></Column>            
                <Column :header="translated('paymentdesctable')" field="Description"></Column>
                <Column :exportable="false" :style="{width:'100px'}">
                    <template #body="slotProps">
                        <Button :disabled="isReadOnly" icon="pi pi-trash" class="p-button-rounded p-button-warning deletebutton" @click="deletePaymentType(slotProps.data)" />
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2 editbutton" @click="openModalEditPaymentType(slotProps.data)" />											
                    </template>
                </Column>	               
            </DataTable>
        </div>  
    </div>  

    <Dialog v-model:visible="displayModalAddPaymentType" :style="{width: '30vw'}" :modal="true" class="globalDialog">
        <template #header>
            <span class="p-dialog-title">{{ popupTitle }}</span>
        </template>	
        <div class="card fluid">       

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('companyname') }}</label>
                <div class="col-12 md:col-8">
                    <InputText type="text" v-model="tmpName" />						
                </div>                        
            </div>	
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('paymenttypepop') }}</label>
                <div class="col-12 md:col-8">
                    <Dropdown v-model="tmpMeanOfpayment" :options="MeanOfPaymentlloptions" optionLabel="label" optionValue="value" :placeholder="translated('selectmeanofpay')" />					
                </div>                        
            </div>	
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('paymentdesctable') }}</label>
                <div class="col-12 md:col-8">
                    <InputText type="text" v-model="tmpDescription" />										
                </div>                        
            </div>							
		
                                                    
        </div>
        <template #footer>
            <Button :label="translated('canclebutton')" icon="pi pi-times" @click="closeModalAddPaymentType" class="p-button-text"/>
            <Button :disabled="isReadOnly" :label="translated('savebutton')" icon="pi pi-check" @click="closeAndAddModalAddPaymentType" autofocus />
        </template>
    </Dialog>    
</template>

<script>

import {FilterMatchMode,FilterOperator} from 'primevue/api';
import createHttp from "@/services/http";
import { computed } from "vue";
import store from "@/store";

// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  data() {
    return {
        translated: computed(() => store.getters.getTranslate),
        paymenttypes : null,
        filters1: null,
        loading1: true,
        displayModalAddPaymentType: false,
        popupTitle: '',
        tmpId:'',
        tmpName:'',
        tmpMeanOfpayment: null,
        tmpDescription: '',
        MeanOfPaymentlloptions: [
            {label: "paymentCard", value: "paymentCard"},
            {label: "cash", value: "cash"},
            {label: "cashCoinsOnly", value: "cashCoinsOnly"},
            {label: "directCashTransfer", value: "directCashTransfer"},
            {label: "electronicSettlement", value: "electronicSettlement"},
            {label: "rfid", value: "rfid"},
            {label: "mobileApp", value: "mobileApp"},
            {label: "payBySMS", value: "payBySMS"},
            {label: "mobilePhone", value: "mobilePhone"},
            {label: "unknown", value: "unknown"},
            {label: "other", value: "other"},
        ]
    }
  },
  created() {
      this.initFilters1();
  },  
  async mounted() {
    const http = createHttp(true); 
    const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetPaymentTypes");
    /*
    console.log('prejel nazaj:')
    console.log(result.data)
    */

    if(result.status==200){
        this.paymenttypes = result.data
    }

    this.loading1 = false
   //console.log(this.paymenttypes)
  },
  methods: {
    getEmptyGuid() {  
        return '00000000-0000-0000-0000-000000000000'
	},
      clearFilter1() {
          this.initFilters1();
      },
      initFilters1() {
          this.filters1 = {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
          }
      },
      openModalAddPaymentType() {
          this.popupTitle = this.translated('addingnewpaymenttype'); //'Adding new payment type'
          this.tmpId = this.getEmptyGuid()
          this.tmpName = ''
          this.tmpDescription = ''
          this.tmpMeanOfpayment = null
          this.displayModalAddPaymentType = true
      },
      openModalEditPaymentType(PaymentTypeObj) {
          this.popupTitle = this.translated('editingpaymenttype'); //'Edit payment type'
          this.tmpId = PaymentTypeObj.Id
          this.tmpName = PaymentTypeObj.Name
          this.tmpDescription = PaymentTypeObj.Description
          this.tmpMeanOfpayment = PaymentTypeObj.MeanOfPayment
          this.displayModalAddPaymentType = true
      },
      closeModalAddPaymentType() {
          this.displayModalAddPaymentType = false
      },
      async closeAndAddModalAddPaymentType() {
            const http = createHttp(true); 
            try {
                /*
                console.log('zacnem klic ADD');
                console.log(http);
                */
                const paymentObj = {
                    Id: this.tmpId,
                    Name: this.tmpName,
                    Description: this.tmpDescription,
                    MeanOfPayment: this.tmpMeanOfpayment,
                    Currency: 'EUR'
                }

                /*
                console.log('parameter:');
                console.log(paymentObj);
                */
                const response = await http.post(process.env.VUE_APP_API_FOLDER + "/InsertUpdatePaymentType", paymentObj );
                //console.log('response na ADD/UPDATE')
                //console.log(response)

                if(response.status==200) {
                    paymentObj.Id = response.data.Id
                    this.paymenttypes.push(paymentObj)
                    /*
                    console.log('VSE JE OK!!!')
                    console.log('payment types:');
                    console.log(this.paymenttypes);
                    */
                    this.$toast.add({severity:'success', summary:'Confirmed', detail:'Record saved!', life: 3000});
                } else {
                    console.log('ERROR!!!')
                    this.$toast.add({severity:'success', summary:'Confirmed', detail:'ERROR', life: 3000});
                }

                //console.log(response)
                
            } catch (error) {
                //console.log('ERROR TRY CATCHE!');
                console.log(error);
                this.$toast.add({severity:'success', summary:'Confirmed', detail:'ERROR', life: 3000});
            }

            this.displayModalAddPaymentType = false
            
      },      
      async deletePaymentType(PaymentTypeObj) {
        this.$confirm.require({
            message: 'Are you sure you want DELETE Payment type?',
            header: 'DELETE?',
            icon: 'pi pi-exclamation-triangle',
            acceptClass: 'p-button-danger',
            accept: async () => {
                //callback to execute when user confirms the action

                const http = createHttp(true); 
                try {
                    //console.log('zacnem klic delete');
                    //console.log(http);
                    const response = await http.delete(process.env.VUE_APP_API_FOLDER + "/DeletePaymentType?id=" + PaymentTypeObj.Id );
                    //console.log('response na DELETE')
                    //console.log(response)

                    if(response.status==200) {
                        /*
                        console.log('VSE JE OK!!!')
                        console.log('payment types:');
                        console.log(PaymentTypeObj.Id);
                        console.log(this.paymenttypes);
                        */
                        // izbrišem še iz kolekcije, da se odstrani iz app
                        const arr = this.paymenttypes.filter(function(item) {                            
                            return item.Id !== PaymentTypeObj.Id
                        })

                        this.paymenttypes = arr                            
                    } else {
                        console.log('ERROR!!!')
                    }

                    //console.log(response)
                } catch (error) {
                    //console.log('ERROR TRY CATCHE!');
                    console.log(error);
                }
                //console.log(PaymentTypeObj);
                this.$toast.add({severity:'success', summary:'Confirmed', detail:'Record deleted', life: 3000});
                //console.log('klical accept');
            },
            reject: () => {
                //console.log('klical reject');
                //callback to execute when user rejects the action
            }
        });
      }
  },
  computed: {
    isReadOnly() {
        return this.$store.getters.isInRole("ReadOnly");
    }
  }  
}
</script>

<style scoped>
 button.deletebutton, button.editbutton {
    position: relative;
    float: right;
}
</style>